module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("47vVL"))).then(() => parcelRequire('hEqeo'));